import { getWithToken, postWithToken, postWithTokenV2 } from 'api/network';
import { Constants } from 'utilities/constants';

export async function GetAsgPropIdsWithImportId(importId, module) {
  const url = module === Constants.Module.EXPLORE
    ? `/api/explore/import/history/getAsgPropIdsByExploreImportId?importId=${importId}`
    : module === Constants.Module.POSTACQ
      ? `/api/postAcquisition/import/history/getAsgPropIdsByPostAcquisitionImportId?importId=${importId}`
      : `/api/underwrite/import/history/getAsgPropIdsByOpportunityImportId?importId=${importId}`
  const response = await getWithToken(url);
  const data = await response.json();
  return data;
}

export async function SearchPropMasterWithLocation(locationDto) {
  const url = `/api/underwrite/import/opportunity/searchLocation`;
  const response = await postWithToken(url, locationDto);
  const data = await response.json();
  return data;
}

export async function CreatePropMasterLocation(locationDto, jitCreationType) {
  const getUrl = () => {
    switch (jitCreationType) {
      case 'properties':
        return '/api/explore/import/property/createLocation';
      case 'prospects':
        return '/api/explore/prospect/createLocation';
      default:
        return `/api/underwrite/import/opportunity/createLocation`;
    }
  }

  const url = getUrl();
  const response = await postWithToken(url, locationDto);
  const data = await response.json();
  return data;
}

export async function BulkCreatePropMasterLocation(locationDto) {
  const url = `/api/underwrite/import/opportunity/bulkCreateLocation`;
  const response = await postWithToken(url, locationDto);
  const data = await response.json();
  return data;
}

export async function validateLatAndLong(latAndLongDto) {
  const url = `/api/underwrite/import/opportunity/validateLatLong`;
  const response = await postWithToken(url, latAndLongDto);
  const data = await response.json();
  return data;
}

export async function importPostAcquisitionOpportunity(importDto) {
  const url = `/api/underwrite/import/postAcquisitions`;
  return await postWithTokenV2(url, importDto);
}